import { render } from "./AddExhibition.vue?vue&type=template&id=6829a914&scoped=true"
import script from "./AddExhibition.vue?vue&type=script&lang=js"
export * from "./AddExhibition.vue?vue&type=script&lang=js"

import "./AddExhibition.vue?vue&type=style&index=0&id=6829a914&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6829a914"]])

export default __exports__